import React from "react";

interface BrandImageProps
  extends Omit<
    React.DetailedHTMLProps<
      React.ImgHTMLAttributes<HTMLImageElement>,
      HTMLImageElement
    >,
    "src"
  > {
  subPath?: string;
  path?: string;
}

const BrandImage: React.FC<BrandImageProps> = ({
  subPath,
  path,
  alt,
  ...rest
}) => {
  const defaultPath = process.env.PUBLIC_URL;

  return (
    <img src={path ?? `${defaultPath}/images/${subPath}`} alt={alt} {...rest} />
  );
};

export default BrandImage;
